/* eslint-disable global-require, import/no-dynamic-require */
import * as React from 'react';
export default function loadVector(name) {
  var vector;

  // Prevent edge cases where an empty string could lead to unexpected
  // behaviours. It would load the `'./'` path, which is this exact module file.
  if (!name) {
    return vector;
  }
  try {
    var required = require("../vectors/".concat(name));
    vector = required.default || required;
    // eslint-disable-next-line no-empty
  } catch (e) {}
  return vector;
}